var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2667 13.9957H1.73629C1.5368 13.9957 1.34548 14.0749 1.20442 14.216C1.06337 14.357 0.984118 14.5483 0.984118 14.7478C0.984118 14.9473 1.06337 15.1386 1.20442 15.2797C1.34548 15.4208 1.5368 15.5 1.73629 15.5H12.2667C12.4662 15.5 12.6575 15.4208 12.7986 15.2797C12.9396 15.1386 13.0189 14.9473 13.0189 14.7478C13.0189 14.5483 12.9396 14.357 12.7986 14.216C12.6575 14.0749 12.4662 13.9957 12.2667 13.9957ZM1.73629 12.4913H1.80399L4.94054 12.2055C5.28413 12.1713 5.60549 12.0199 5.85067 11.7767L12.6202 5.0072C12.883 4.72962 13.025 4.35921 13.0151 3.97712C13.0052 3.59504 12.8443 3.23245 12.5676 2.96881L10.5066 0.907858C10.2376 0.655201 9.88516 0.510229 9.51626 0.500521C9.14735 0.490813 8.78774 0.617046 8.50584 0.855206L1.73629 7.62476C1.49316 7.86994 1.34178 8.1913 1.30755 8.53488L0.984118 11.6714C0.973986 11.7816 0.988281 11.8927 1.02599 11.9967C1.06369 12.1007 1.12387 12.1951 1.20225 12.2732C1.27253 12.3429 1.35588 12.398 1.44753 12.4355C1.53917 12.4729 1.6373 12.4919 1.73629 12.4913ZM9.4611 1.9609L11.5145 4.01433L10.0102 5.48107L7.99436 3.46524L9.4611 1.9609Z",
    fill: "#A9876F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionIcon);
export default __webpack_public_path__ + "static/media/ActionIcon.269f9ef29aefd46ef3489970e3f47c77.svg";
export { ForwardRef as ReactComponent };